import { AxiosRequestConfig } from 'axios'
import { apiRequest } from 'src/state/utils/request'

// Orval mutator: routes every generated hook through the shared axios layer
// (config-store baseURL, auth interceptors, ImmutableVector3 reviver, 409/424 -> null)
export const customInstance = async <T>(config: AxiosRequestConfig): Promise<T> => {
  const response = await apiRequest<T>(config)

  // The response interceptor resolves GET 409/424 (data not yet available) to
  // { data: null }, so T may be null at runtime for those endpoints, matching
  // the behavior of the hand-written request helpers.
  return response.data as T
}

export default customInstance
